module.exports = __webpack_public_path__ + "static/fonts/Poppins-MediumItalic.cf5ba39.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-MediumItalic.ttf
// module id = 1029
// module chunks = 11